<template>
  <div>
    <!-- 申请充值模态框 -->
    <ModalDialog
      :dialogData="rechargeDialogData"
      @dialogConfirm="rechargeHandleConfirm"
      @dialogClose="RechargeDialogClose"
      :checkTitle="checkTitle"
    >
      <template slot="content">
        <el-form
          :model="rechargeFormData"
          :rules="rechargeDialogRules"
          ref="rechargeForm"
          label-position="right"
          label-width="96px"
          v-if="applicationProcess == 1 && isVisible"
        >
          <el-form-item label="金额" prop="money">
            <el-input v-model="rechargeFormData.money" placeholder="请输入金额">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="64 64 896 896" width="40" height="40" style="fill: rgba(242, 161, 6, 1);"><path d="M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z"></path></svg>
            </el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark" required>
            <el-input type="textarea" v-model="rechargeFormData.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
        <div class="qr-code-wrapper" v-if="applicationProcess == 2">
          <el-button class="copyBtn" size="medium" @click="copyText()">一键复制</el-button>
          <div class="link-title">点击此链接扫码进行支付宝授权入金</div>
          <a ref="copyText" target="_blank" :href="this.inGoldUrl">{{this.inGoldUrl}}</a>
        </div>
        <div class="recharge-success" v-if="applicationProcess == 3">
          <i class="el-icon-success" style="font-size: 40px; color: #409eff;"></i>
          <div class="recharge-success-tips">已发起入金申请，成功后会自动匹配到账</div>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import ModalDialog from "./ModalDialog.vue";
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    inGoldTitle: {
      type: String,
      default: ''
    }
  },
  components: {
    ModalDialog,
  },
  data() {
    return {
      isCopy: false,
      inGoldUrl: '',
      rechargeDialogData: {
        visible: false,
        title: "金额授权",
        width: "30%",
        loading: true,
        modal: false,
      },
      checkTitle: '申请',
      applicationProcess: 1,
      rechargeFormData: {
       remark: '',
        money: ''
      },
      rechargeDialogRules: {
        money: [{
          required: true, message: '请输入金额', trigger: 'blur'
        }],
		remark: [{
          required: true, message: '请输入备注', trigger: 'blur'
        }],
      },
    };
  },
  watch: {
    "isVisible": function(val) {
      this.rechargeDialogData.visible = val
    },
    "rechargeFormData.money": function(val) {
      if(val) {
        this.rechargeDialogData.loading = false
      }else {
        this.rechargeDialogData.loading = true
      }
    },
    "applicationProcess": function(val) {
        if(val == 2 || val == 3) {
            this.checkTitle = '完成'
        }else {
            this.checkTitle = '申请'
        }
    }
  },
  methods: {
    copyText() {
      var that = this 
      if(!that.isCopy) {
        var clipboard = new this.clipboard('.copyBtn', {
          target: function() {
            return that.$refs.copyText
          }
        });
      }
      clipboard.on('success', function() {
        that.$message.success('复制成功')
      });
      clipboard.on('error', function() {
        that.$message.success('复制失败')
      });
      that.isCopy = true
    },
    //申请充值确定事件
    rechargeHandleConfirm() {
      switch(this.applicationProcess) {
        case 1: this.rechargeAmount(); break;
        case 2: this.whetherToPay(); break;
        case 3: this.checkRecharge(); break;
        default: break;
      }
    },
    //充值金额
    async rechargeAmount() {
      this.$refs['rechargeForm'].validate((valid) => {
        if(valid) {
          this.rechargeAmountSubmit()
        }
      })
    },
    //充值金额提交
    async rechargeAmountSubmit(){
      try {
        let args = {
          channel_account: this.mxSettlementId,
          company_id: this.mxCompanyId ,
          money: this.rechargeFormData.money,
          remark: this.rechargeFormData.remark
        }
        let result = await this.$api.alipayRecharge(args)
        if(result) {
          this.applicationProcess = 2
          this.inGoldUrl = result.url
        }
      } catch (error) {
        console.log(error)
      }
    },
    //确定是否入金成功
    whetherToPay() {
      this.applicationProcess = 3
    },
    //确定完成充值事件
    checkRecharge() {
      this.rechargeDialogData.visible = false
      this.applicationProcess = 1
      this.$emit('emitCheckRecharge', this.rechargeDialogData.visible)
      this.rechargeFormData = {}
    },
    //申请充值关闭事件
    RechargeDialogClose() {
      this.rechargeDialogData.visible = false
      this.applicationProcess = 1
      this.$emit('emitRechargeDialogClose', this.rechargeDialogData.visible)
      this.rechargeFormData = {}
      // this.$refs['rechargeForm'].resetFields()
    },
  }
};
</script>
<style lang="stylus" scoped>
.qr-code
  width: 266px
  height: 266px
  margin: 0 auto
  border: 1px solid black
.qr-code-tips
  text-align: center
  margin-right: 100px
  color: #EE0A0A
.recharge-success
  display: flex;
  justify-content: center;
.recharge-success-tips
  font-size: 20px
  margin-top:10px
  padding: 0 10px
.link-title
  text-align: center
  padding-bottom: 10px
  color: red
.copyBtn
  position: relative
  top: -15px
  left: 84%
</style>
